import { makeAutoObservable } from "mobx";
import currentPortalStore from "../current-portal-store";
import CustomizationClassicStore from "./customization-classic-store";
import CustomizationEdgeStore from "./customization-edge-store";

class CustomizationStore
{
    private _isLoading: boolean = false;
    private readonly _classicStore: CustomizationClassicStore = new CustomizationClassicStore();
    private readonly _edgeStore: CustomizationEdgeStore = new CustomizationEdgeStore();

    public get isLoading(): boolean { return this._isLoading; }

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }

    private get isPortalV2Enabled(): boolean { return !!currentPortalStore.setting?.enablePortalV2; }

    public getSelectedStore(): CustomizationEdgeStore | CustomizationClassicStore {
        return this.isPortalV2Enabled ? this._edgeStore : this._classicStore;
    }

    public getClassicStore(): CustomizationClassicStore {
        return this._classicStore;
    }

    public getEdgeStore(): CustomizationEdgeStore {
        return this._edgeStore;
    }

    public async load() {
        this._isLoading = true;

        try {
            await Promise.all([
                this.getClassicStore().load(),
                this.getEdgeStore().load(),
            ]);
        } finally{
            this._isLoading = false;
        }
    }

    public async save() {
        const edgeCustomizationStore = this.getEdgeStore();
        const classicCustomizationStore = this.getClassicStore();

        const promises = [];

        if (edgeCustomizationStore.hasChanges()) {
            promises.push(edgeCustomizationStore.save());
        }
        if (classicCustomizationStore.hasChanges()) {
            promises.push(classicCustomizationStore.save());
        }

        await Promise.all(promises);
    }

    public hasChanges(): boolean {
        const edgeCustomizationStore = this.getEdgeStore();
        const classicCustomizationStore = this.getClassicStore();

        return edgeCustomizationStore.hasChanges() || classicCustomizationStore.hasChanges();
    }

    public discardChanges(): void {
        const edgeCustomizationStore = this.getEdgeStore();
        const classicCustomizationStore = this.getClassicStore();

        edgeCustomizationStore.discardChanges();
        classicCustomizationStore.discardChanges();
    }
}

const customizationStore = new CustomizationStore();
export default customizationStore;
